import { WorkflowModelsNS } from 'src/app/misc/workflow/models/add-update-workflow.models';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wfApprovalsGroup'
})
export class WorkflowApprovalsGroupPipe implements PipeTransform {

    transform(items: WorkflowModelsNS.WorkflowAddEditActionApprovals[]): any {
        if (!items) return [];

        const grouped = items.reduce((acc, current) => {
            const objectId = current.objectId;
            if (!acc[objectId]) {
                acc[objectId] = {
                    objectId: current.objectId,
                    objectName: current.objectName,
                    count: 0,
                    workflowActionApprovals: []
                };
            }
            acc[objectId].count++;
            acc[objectId].workflowActionApprovals.push(current);
            return acc;
        }, {});

        return Object.values(grouped);
    }
}
